/* eslint-disable @typescript-eslint/no-empty-function */
import React, { createContext, useEffect, useState } from 'react'

export interface CertificateObject {
  id?: number
  type: { id: number, typeName: string }
  material: string
  profile: string
  heatNumber: { id: number, heatNumber: string }
  standard: string
  conformation: string
  heatTreatment: string
  mechanicalTest: string
  nf: string
  date?: any
  description: string
  structures: StructureDataObject[]
  customerCompany:{id:number, companyName:string}
  supplierCompany:{id:number, companyName:string}
  supplierFile: File | null
}

export interface StructureDataObject {
  id?: number
  name: string
  fileImport: boolean
  hasTable: boolean
  tableData: string[][]
  minTable: string[][]
  maxTable: string[][]
  tableRows: string[]
  tableColumns: string[]
  format: string
  structureFile: File | null
}

export const initialCertificateState: CertificateObject = {
  type: { id: 0, typeName: '' },
  material: '',
  profile: '',
  heatNumber: { id: 0, heatNumber: '' },
  standard: '',
  conformation: '',
  heatTreatment: '',
  mechanicalTest: '',
  nf: '',
  description: '',
  structures: [],
  customerCompany:{id:0, companyName:''},
  supplierCompany:{id:0, companyName:''},
  supplierFile: null
}

interface CertificatesContextProps {
  certificatesTableQuantity: number
  setCertificatesTableQuantity: React.Dispatch<React.SetStateAction<number>>
  allCertificates: CertificateObject[]
  setAllCertificates: React.Dispatch<React.SetStateAction<CertificateObject[]>>
  certificate: CertificateObject
  setCertificate: React.Dispatch<React.SetStateAction<CertificateObject>>
  structureData: StructureDataObject[]
  setStructureData: React.Dispatch<React.SetStateAction<StructureDataObject[]>>
  forWhom:string
  setForWhom:React.Dispatch<React.SetStateAction<string>>
}

const CertificatesContext = createContext<CertificatesContextProps>({
  certificatesTableQuantity: 7,
  setCertificatesTableQuantity: () => {},
  allCertificates: [],
  setAllCertificates: () => {},
  certificate: initialCertificateState,
  setCertificate: () => {},
  structureData: [],
  setStructureData: () => {},
  forWhom: '',
  setForWhom: () => {}
})

export default CertificatesContext

export const CertificatesProvider: React.FC<any> = ({ children }) => {
  const [ certificatesTableQuantity, setCertificatesTableQuantity ] = useState<number>(7)
  const [ allCertificates, setAllCertificates ] = useState<CertificateObject[]>([])
  const [ certificate, setCertificate ] = useState<CertificateObject>(initialCertificateState)
  const [ structureData, setStructureData ] = useState<StructureDataObject[]>([])
  const [ forWhom, setForWhom ] = useState<string>('')

  return (
    <CertificatesContext.Provider
      value={{
        certificatesTableQuantity,
        setCertificatesTableQuantity,
        allCertificates,
        setAllCertificates,
        certificate,
        setCertificate,
        structureData,
        setStructureData,
        forWhom,
        setForWhom
      }}
    >
      {children}
    </CertificatesContext.Provider>
  )
}
